import type { AxiosResponse } from 'axios';

import { ADMIN, baseRoutes, baseRoutesV2 } from '@/api/config';
import type { ResponseWithPagination } from '@/utils/types';

import axiosInstance from '../../instance';
import ROUTES from '../../routes';
import type {
  DeviceBody, DeviceCreateBody, DevicesFilters, DeviceUpdateBody, IDevice, IDeviceCoordinates, TGetFilters,
} from './types';

export const create = (data: DeviceCreateBody)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.DEVICES}/new`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getAll = (data: Partial<DeviceBody>)
  : Promise<void | AxiosResponse<ResponseWithPagination<IDevice>>> => axiosInstance({
  url: `${ROUTES.DEVICES}/select`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getIds = (): Promise<void | AxiosResponse<string []>> => axiosInstance({
  url: `${ROUTES.DEVICES}/ids`,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const getFilters = (deviceType: TGetFilters)
  : Promise<void | AxiosResponse<DevicesFilters>> => axiosInstance(
  deviceType ? {
    baseURL: baseRoutesV2 + ADMIN,
    url: `${ROUTES.DEVICES}/select/filters`,
    method: 'POST',
    headers: {
      authorization: true,
    },
    data: { hw_type: deviceType },
  }
    : {
      url: `${ROUTES.DEVICES}/select/filters`,
      method: 'GET',
      headers: {
        authorization: true,
      },
    },
);

export const update = (id: string, data: DeviceUpdateBody)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.DEVICES}/${id}`,
  method: 'PATCH',
  headers: {
    authorization: true,
  },
  data,
});

export const getGps = (data: string[])
  : Promise<void | AxiosResponse<IDeviceCoordinates>> => axiosInstance({
  baseURL: baseRoutes + ADMIN,
  url: `${ROUTES.DEVICES}/get-gps`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const tabletScreenshot = (id: string): Promise<AxiosResponse<Blob>> => axiosInstance({
  url: `${ROUTES.DEVICES}/${id}/tablet-screenshot-command`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  responseType: 'blob',
});
